import { Trans } from "@lingui/react/macro";
import { Chip } from "@silversea-ssc/ui-components-react";
import React from "react";
import clsx from "clsx";
import * as styles from "./IncludedWithOptionalFlightPackage.module.scss";

type Props = {
  className?: string;
};

const IncludedWithOptionalFlightPackage: React.FC<Props> = ({ className }) => {
  return (
    <Chip background="transparent" className={clsx(styles.outline, className)}>
      <Trans>
        With optional <strong>Flight Package</strong>
      </Trans>
    </Chip>
  );
};

export default IncludedWithOptionalFlightPackage;
